// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import App from './App';
// import AuthProvider from './store/authProvider';


// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <AuthProvider>
//     {/* <FavcontextProvider> */}
//     <React.StrictMode>
//       {/* <ProSidebarProvider> */}
//       <App />
//       {/* </ProSidebarProvider> */}
//     </React.StrictMode>
//     {/* </FavcontextProvider> */}
//   </AuthProvider>,

// );
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import AuthProvider from './store/authProvider';
import './i18n/config'; // Import i18n configuration
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n/config';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <I18nextProvider i18n={i18n}>
    <AuthProvider>
      {/* <FavcontextProvider> */}
      <React.StrictMode>
        {/* <ProSidebarProvider> */}
        <App />
        {/* </ProSidebarProvider> */}
      </React.StrictMode>
      {/* </FavcontextProvider> */}
    </AuthProvider>
  </I18nextProvider>,
);